import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';

const ImagePopup = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    
    const popupInteracted = localStorage.getItem('popupInteracted');

    if (!popupInteracted) {
      // Show the popup after a delay (15 seconds)
      const timer = setTimeout(() => {
        setIsVisible(true);
        localStorage.setItem('popupShown', 'true'); 
      }, 15000);

      // Cleanup timer when component unmounts
      return () => clearTimeout(timer);
    }
  }, []);

  const closePopup = () => {
    setIsVisible(false);
    localStorage.setItem('popupInteracted', 'true'); 
  };

  // Handle Escape key to close the popup
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && isVisible) {
        closePopup();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isVisible]);

  return (
    <>
      {isVisible && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
          <div className="relative bg-white rounded-lg shadow-lg max-w-md w-[80%] md:w-full">
            {/* Close Button */}
            <button
              onClick={closePopup}
              className="absolute top-2 right-2 text-gray-700 hover:text-black"
              aria-label="Close popup"
            >
              <FaTimes size={24} />
            </button>

            <a
              href="/contact"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Open form"
              onClick={closePopup} 
            >
              <img
                src="/popupimage.webp"
                alt="Join our demo class"
                className="w-full rounded-lg mb-2"
                loading="lazy"
              />
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default ImagePopup;
